<template>
  <fragment>
    <iframe
      :src="
        `${this.quoteUrlNew}/app/sidebar?token=${api_token}&lang=${
          $i18n.locale
        }-${
          $i18n.locale === 'fr'
            ? $i18n.locale.toUpperCase()
            : $i18n.locale === 'en'
            ? 'GB'
            : 'SE'
        }`
      "
      :key="$i18n.locale"
      width="100%"
      height="100%"
      style="height:100vh;"
      frameBorder="0"
    />

    <b-sidebar
      id="sidebar-refill-account"
      width="630px"
      title=""
      shadow
      right
      backdrop
    >
      <iframe
        :src="
          `${this.quoteUrlNew}/app/account/refill?token=${api_token}&lang=${
            $i18n.locale
          }-${
            $i18n.locale === 'fr'
              ? $i18n.locale.toUpperCase()
              : $i18n.locale === 'en'
              ? 'GB'
              : 'SE'
          }`
        "
        width="100%"
        height="100%"
        frameBorder="0"
      />
    </b-sidebar>
  </fragment>
</template>
<script>
import router from '../router';
export default {
  data() {
    return {
      quoteUrlNew: process.env.VUE_APP_QUOTES_URL_NEW,
    };
  },
  mounted() {
    window.addEventListener('message', (event) => {
      if (event.origin === this.quoteUrlNew && event.data.startsWith('page')) {
        const page = event.data.replace('page:', '');

        if (page !== 'refill') {
          router.replace(`/${page}`);
        } else {
          this.showRefillSidebar();
        }
      }
    });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    api_token() {
      return sessionStorage.getItem('api_token');
    },
  },
  methods: {
    saveLang() {
      localStorage.setItem('lang', this.$i18n.locale);
      document.documentElement.setAttribute(
        'lang',
        this.$i18n.locale.toLowerCase(),
      );
    },
    showRefillSidebar() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-refill-account');
    },
  },
};
</script>
<style lang="scss">
.logo {
  border-radius: 20px;
  margin-bottom: 5px;
  width: 120px;
  height: 120px;
}

iframe {
  overflow: hidden;
  height: 100vh;
}

#sidebar-refill-account {
  > header.b-sidebar-header {
    background: rgb(20, 133, 211);
  }

  .b-sidebar-body {
    overflow: hidden;
  }

  iframe {
    overflow: hidden;
    height: 100vh;
  }
}
</style>
